import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { DateTime } from 'luxon';
import { TaskStatus } from '@cf-shared/data-model/day-task-status-cache';
import { formatWeekdayNarrow } from '@cf-shared/date-format';
import { BOOT_LOCALE } from 'i18n/i18n.service';

// the enum moved to the shared data model so non-Angular code and unit tests
// can use it (#4212); re-export it here so existing imports keep working
export { TaskStatus };

@Component({
  selector: 'cs-task-calendar-day',
  templateUrl: 'cs-task-calendar-day.html',
  host: {
    'class': 'task-calendar-day'
  },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTaskCalendarDay {
  @HostBinding('class.task-calendar-day--completed')
  get isCompleted() { return this.taskStatus === TaskStatus.Completed; }

  @HostBinding('class.task-calendar-day--incomplete')
  get isIncomplete() { return this.taskStatus === TaskStatus.Incomplete; }

  @HostBinding('class.task-calendar-day--future')
  get isFuture() { return this.taskStatus === TaskStatus.Future; }

  @HostBinding('class.task-calendar-day--in-progress')
  get isInProgress() { return this.taskStatus === TaskStatus.InProgress; }

  @HostBinding('class.task-calendar-day--no-task')
  get isNoTask() { return this.taskStatus === TaskStatus.NoTask; }

  @HostBinding('class.task-calendar-day--selected')
  get isSelectedClass() { return this.isSelected; }

  @HostBinding('class.task-calendar-day--today')
  get isTodayClass() { return this.isToday; }

  @Input() date: DateTime;
  @Input() taskStatus: TaskStatus = TaskStatus.NoTask;
  @Input() isSelected: boolean = false;
  @Input() isToday: boolean = false;
  @Input() showDayOfWeek: boolean = true;
  @Input() showStatus: boolean = true;
  @Output() dateClick = new EventEmitter<DateTime>();

  get dayOfMonth(): number {
    return this.date.day;
  }

  get dayOfWeek(): string {
    // the single letter comes from the date itself in the active UI language
    // (#4317). It used to be a hardcoded English array, so a Spanish user saw
    // "S M T W T F S" instead of "D L M X J V S".
    return formatWeekdayNarrow(this.date, BOOT_LOCALE);
  }

  handleClick(ev: Event) {
    void ev;
    this.dateClick.emit(this.date);
  }

  getStatusIcon(): string {
    switch (this.taskStatus) {
      case TaskStatus.Completed:
        return 'checkmark-circle';
      case TaskStatus.Incomplete:
        return 'radio-partial';
      case TaskStatus.InProgress:
        return 'time';
      case TaskStatus.Future:
        return 'circle';
      case TaskStatus.NoTask:
        return 'circle';
      default:
        return '';
    }
  }
}
